import { NoSsr } from "@mui/base";
import type { FunctionComponent } from "react";

import { theme } from "shared/lib/styles";

import { AdSlot } from "scmp-app/components/advertisement/ad-slots/ad-slot";
import { TargetingPaidType } from "scmp-app/components/advertisement/ad-slots/types";
import { FeedView } from "scmp-app/components/my-news/feed-view";
import { MynewsCard } from "scmp-app/components/my-news/mynews-card";

import {
  AdSlotContainer,
  DesktopAdSlotContainer,
  StyledMyDailyFive,
  StyledMynewsHeader,
} from "./styles";

export const Mynews: FunctionComponent = () => {
  const largeStyles = {
    $height: 250,
    $padding: 20,
  };
  const smallStyles = {
    $height: 100,
    $padding: 10,
  };

  const bindAdSlotContainer = {
    $responsiveVariants: {
      desktopUp: largeStyles,
      mobileUp: smallStyles,
      tabletUp: smallStyles,
    },
  };

  const adZone = "mynews/home";

  return (
    <>
      <NoSsr>
        <DesktopAdSlotContainer>
          <AdSlotContainer {...bindAdSlotContainer}>
            <AdSlot
              adUnit="d_banner1"
              breakpoint={theme.breakpoints.up("desktop")}
              sizes={[[970, 250], [728, 90], [970, 90], "fluid"]}
              targeting={{
                paid: TargetingPaidType.Free,
              }}
              withBackground
              zone={adZone}
            />
          </AdSlotContainer>
        </DesktopAdSlotContainer>
      </NoSsr>
      <StyledMynewsHeader isShowIndicatorIcon />
      <StyledMyDailyFive />
      <FeedView />
      <MynewsCard />
    </>
  );
};

Mynews.displayName = "Mynews";
